import script from "./ProjectCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCarousel.vue?vue&type=style&index=0&id=df0ec4da&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df0ec4da"]])

export default __exports__